import React, { useState, useEffect } from "react";
import styled from "styled-components";

const StyledContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #00ccff;
  color: #fff;
  padding: 25px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const StyledText = styled.p`
  margin: 0;
  font-size: 20px;
  text-align: center;
`;

const StyledButtons = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 10px;
`;

const StyledButton = styled.button`
  background: #0088cc;
  border: none;
  border-radius: 10px;
  color: #fff;
  padding: 14px 20px;
  cursor: pointer;
  font-size: 16px;
  &:hover {
    background: #005f8c;
  }
`;

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "akzeptiert");
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "abgelehnt");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <StyledContainer>
      <StyledText>
        Troniq.news nutzt KI-Technologie, um Ihnen ein besseres Erlebnis auf unserer Plattform zu bieten. Bitte stimmen Sie der Nutzung zu.
      </StyledText>
      <StyledButtons>
        <StyledButton onClick={handleAccept}>Zustimmen</StyledButton>
        <StyledButton onClick={handleDecline}>Ablehnen</StyledButton>
      </StyledButtons>
    </StyledContainer>
  );
};

export default CookieBanner;